import React from "react";
import PropTypes from "prop-types";

function LinearDivider(props) {
  const { width } = props;

  const styles = {
    width: "100%",
    display: "flex",
    paddingRight: "30px",
    justifyContent: "flex-end",
  };

  return (
    <div style={styles}>
      <div className="linear-divider" style={{ width: width }} />
    </div>
  );
}

LinearDivider.propTypes = {
  width: PropTypes.string.isRequired,
  right: PropTypes.string,
};

export default LinearDivider;
